import script from "./chanping-3.vue?vue&type=script&setup=true&lang=js"
export * from "./chanping-3.vue?vue&type=script&setup=true&lang=js"

import "./chanping-3.vue?vue&type=style&index=0&id=115e8ac5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-115e8ac5"]])

export default __exports__